import React, { FunctionComponent, ReactNode } from 'react';
import { FullScreenWrapper } from 'components/Layouts/FullScreenView/FullScreenWrapper';
import { EventModel } from 'features/events/EventModel';
import { useIsEventLive } from 'features/events/eventHooks';
import { useSelector } from 'react-redux';
import { RootState } from 'rootReducer';
import { useAppSelector } from 'hooks/redux';
import { currentBroadcastFinishedSelector } from 'features/broadcast/selectors';

interface EventWrapperProps {
  children: ReactNode;
  event: EventModel | null;
}

export const EventWrapper: FunctionComponent<EventWrapperProps> = ({
  children,
  event
}) => {
  const isLive = useIsEventLive(event);
  const chatVisible = useSelector((state: RootState) => state.chat.isVisible);
  const currentBroadcastFinished = useAppSelector(
    currentBroadcastFinishedSelector
  );
  const eventChatVisible = chatVisible && (isLive || currentBroadcastFinished);

  if (!event) {
    return null;
  }

  return (
    <FullScreenWrapper
      artworkKey={event.artworkKey}
      artworkMode={event.artworkMode}
      updatedTimestamp={event.lastUpdatedAt}
      type={'event'}
      chatVisible={eventChatVisible}
    >
      {children}
    </FullScreenWrapper>
  );
};
